import styles from "./Heading.module.css";

const Heading = (props) => {
  return (
    <h1 className={`${styles.heading} ${props.className}`}>
      <span className={styles["text--1"]}>{props.text1}</span>
      &nbsp;
      <span className={styles["text--2"]}>{props.text2}</span>
    </h1>
  );
};

export default Heading;
